import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { EntitlementFeatureType } from './entitlement.types';

type HasPaidForFeatureQueryParams = {
  companyId: number;
  featureType: EntitlementFeatureType;
  corporationId?: number;
  complianceId?: string;
};

function useHasPaidForFeature(params: HasPaidForFeatureQueryParams) {
  const query = new URLSearchParams();
  query.append('companyId', params.companyId?.toString());
  query.append('featureType', params.featureType);
  if (params.corporationId) {
    query.append('corporationId', params.corporationId.toString());
  }
  if (params.complianceId) {
    query.append('complianceId', params.complianceId);
  }

  const {
    data,
    error,
    mutate,
  }: {
    data?: { hasAccess: boolean };
    error?: unknown;
    mutate: KeyedMutator<{ hasAccess: boolean }>;
  } = useSWR(
    params.companyId ? `entitlements/hasPaidForFeature?${query}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}

export { useHasPaidForFeature };
